export const TIME_MACHINE_CONFIG = {
  DEFAULT_MIN_WEEK: -52,
  DEFAULT_MAX_WEEK: 0,
  WEEK_IN_MS: 7 * 24 * 60 * 60 * 1000
} as const;

export function clampWeek(week: number, minWeek: number, maxWeek: number): number {
  return Math.max(minWeek, Math.min(maxWeek, week));
}

export function weekToDate(weekNumber: number): Date {
  const now = new Date();
  return new Date(now.getTime() + weekNumber * TIME_MACHINE_CONFIG.WEEK_IN_MS);
}

export function formatWeekDate(weekNumber: number): string {
  const date = weekToDate(weekNumber);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function getWeekLabel(weekNumber: number): string {
  if (weekNumber === 0) return 'Current week';
  return `Week ${weekNumber > 0 ? '+' : ''}${weekNumber}`;
}

export function getRelativeWeekLabel(weekNumber: number): string {
  const absWeek = Math.abs(weekNumber);
  if (weekNumber === 0) return 'Current';
  if (weekNumber < 0) return `${absWeek}w ago`;
  return `${absWeek}w ahead`;
}
